import { render } from "./MainFooter.html?vue&type=template&id=c2d36394&scoped=true"
import script from "./MainFooter.vue?vue&type=script&lang=ts"
export * from "./MainFooter.vue?vue&type=script&lang=ts"

import "./MainFooter.css?vue&type=style&index=0&id=c2d36394&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c2d36394"

export default script